module.exports = __webpack_public_path__ + "img/icon4.75ac602d.svg";